import { MasterButton } from "App/Component/ui";
import { instance2 } from "App/constants";
import { oneMonthBeforeToday } from "App/utils/helpers";
import moment from "moment";

export const urlGet = "/mobile/tarif/list-paket";
export const urlDelete = "/mobile/tarif/delete-paket-header";
export const statusAktif = 1;
export const statusNonAktif = 0;

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  nama: "",
  code: "",
  status: "",
  status_nama:"Pilih Status",
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: moment(new Date()).local().toDate(),
  status_tgl: false,
};

export const getByFilterPaket = async (formFilter, pages, limit) => {
  try {
    const api = await instance2.get(urlGet, {
      params: {
        pages: pages,
        limit: limit,
        id: formFilter.id,
        nama: formFilter.nama,
        code: formFilter.code,
        status: formFilter.status,
        tanggal_awal: formFilter.status_tgl
          ? moment(formFilter.tanggal_awal).format("YYYY-MM-DD")
          : "",
        tanggal_akhir: formFilter.status_tgl
          ? moment(formFilter.tanggal_akhir).format("YYYY-MM-DD")
          : "",
      },
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data.list,
        meta: {
          count: parseInt(res.meta_data.count),
          pages: parseInt(res.meta_data.pages),
          limit: parseInt(res.meta_data.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteById = async (id) => {
  try {
    const api = await instance2.post(urlDelete, { id }, {});
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "CODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "total_diskon",
    disablePadding: false,
    label: "TOTAL DISKON",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tax",
    disablePadding: false,
    label: "TAX",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "total_tax",
    disablePadding: false,
    label: "TOTAL TAX",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "biaya_lain",
    disablePadding: false,
    label: "BIAYA LAIN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_start",
    disablePadding: false,
    label: "TGL MULAI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_expired",
    disablePadding: false,
    label: "TGL EXPIRED",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusPaket = ({ status }) => {
    if (status === statusAktif) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"AKTIF"}
          color={"green"}
          type='button'
          disabled
        />
      );
    } else if (status === statusNonAktif) {
      return (
        <MasterButton
          style={{ borderRadius: 20 }}
          name={"NON-AKTIF"}
          color={"danger"}
          type='button'
          disabled
        />
      );
    } else {
      return <p> Tidak ditemukan</p>;
    }
  };